import { AlertTriangle, Clock, DollarSign, Heart, HelpCircle } from "lucide-react"

function ResponsibleGambling() {
  return (
    <div className="text-white">
      <div className="flex items-start mb-6">
        <div className="bg-yellow-500/20 p-2 rounded-full mr-3 mt-1">
          <AlertTriangle className="w-6 h-6 text-yellow-400" />
        </div>
        <div>
          <h2 className="text-xl font-bold mb-2">Responsible Gambling Alert</h2>
          <p className="text-gray-300">
            Gambling can be a source of entertainment and excitement, but it also carries risks. To ensure your
            experience remains enjoyable, it's crucial to gamble responsibly.
          </p>
        </div>
      </div>

      <div className="space-y-6 mt-8">
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-5 border border-gray-700">
          <div className="flex items-start">
            <div className="bg-emerald-500/20 p-2 rounded-full mr-3">
              <Clock className="w-5 h-5 text-emerald-400" />
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2">Set Limits</h3>
              <p className="text-gray-300">
                Establish limits on how much time and money you'll spend on gambling. Stick to these limits and avoid
                chasing losses.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-5 border border-gray-700">
          <div className="flex items-start">
            <div className="bg-emerald-500/20 p-2 rounded-full mr-3">
              <DollarSign className="w-5 h-5 text-emerald-400" />
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2">Know Your Finances</h3>
              <p className="text-gray-300">
                Only gamble with money you can afford to lose. Avoid using funds designated for essential expenses such
                as bills, groceries, or savings.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-5 border border-gray-700">
          <div className="flex items-start">
            <div className="bg-emerald-500/20 p-2 rounded-full mr-3">
              <Heart className="w-5 h-5 text-emerald-400" />
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2">Monitor Your Emotions</h3>
              <p className="text-gray-300">
                Gambling should never be used as a way to escape stress, anxiety, or other emotional difficulties. If
                you find yourself relying on gambling to cope, seek support.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-5 border border-gray-700">
          <div className="flex items-start">
            <div className="bg-emerald-500/20 p-2 rounded-full mr-3">
              <Clock className="w-5 h-5 text-emerald-400" />
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2">Take Breaks</h3>
              <p className="text-gray-300">
                Regularly take breaks from gambling to reassess your behavior and its impact on your life. Engage in
                other activities you enjoy to maintain balance.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-5 border border-gray-700">
          <div className="flex items-start">
            <div className="bg-emerald-500/20 p-2 rounded-full mr-3">
              <HelpCircle className="w-5 h-5 text-emerald-400" />
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2">Seek Help</h3>
              <p className="text-gray-300">
                If you're concerned about your gambling habits or believe you may have a gambling problem, seek support
                from trusted friends, family, or professional resources.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 bg-gray-900/50 backdrop-blur-sm rounded-xl p-6 border border-gray-800">
        <p className="text-lg font-medium mb-4">
          Remember, gambling should be a form of entertainment, not a means to financial gain or a solution to personal
          problems. Stay mindful of your behavior and prioritize your well-being above all else.
        </p>
        <p className="text-xl font-bold text-emerald-400">Please gamble responsibly.</p>
      </div>
    </div>
  )
}

export default ResponsibleGambling

